import styled from '@emotion/styled'
import Select from '@mui/material/Select'
import { css } from '@emotion/react'
import { theme } from 'styles/theme/hav-theme'
import { InputLabel, FormControl } from '@mui/material'
import { KeyboardArrowDown } from '@mui/icons-material'

export const FormControlStyled = styled(FormControl)`
  width: fit-content;
  .MuiSelect-select {
    padding: 0 18px 0 4px !important;
    border-radius: 5px;
    color: ${theme.colors.primary.main};
    font-weight: ${theme.typography.weight.lg};
  }
`

export const SelectStyled = styled(Select)`
  font-size: ${theme.typography.sizes.xs};
  background-color: transparent;
  border-radius: 5px;
  background-color: ${theme.colors.quartenary};
  cursor: pointer;

  .MuiSelect-select span {
    width: 100%;
    display: flex;
    overflow: hidden;

    ${({ disabled }) =>
      disabled &&
      css`
        -webkit-text-fill-color: ${theme.colors.neutral.medium};
      `}
  }

  .Mui-disabled {
    cursor: not-allowed;
    background-color: ${theme.colors.neutral[100]};
  }
`

export const LabelStyled = styled(InputLabel)`
  margin: 0;
  z-index: 0;
  cursor: inherit;
  color: ${theme.colors.neutral.medium};
  font-size: ${theme.typography.sizes.xs};
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};
  overflow: initial;
  position: relative;
  -webkit-transform: initial;
  transform: initial;
`

export const ChevronDownIconStyled = styled(KeyboardArrowDown)`
  font-size: 18px;
  fill: ${theme.colors.primary.main};
`
